import { useQuery } from '@tanstack/react-query';
import styles from './MaintenanceBanner.module.css';

type PublicPlatform = {
  maintenance: { enabled: boolean; message: string };
};

async function fetchPublic(): Promise<PublicPlatform> {
  const res = await fetch('/api/platform/public', { credentials: 'include' });
  if (!res.ok) return { maintenance: { enabled: false, message: '' } };
  return res.json() as Promise<PublicPlatform>;
}

export function MaintenanceBanner() {
  const q = useQuery({
    queryKey: ['platform', 'public'],
    queryFn: fetchPublic,
    staleTime: 60_000,
  });

  if (!q.data?.maintenance.enabled) return null;

  return (
    <div className={styles.banner} role="status">
      <strong>Onderhoudsmodus</strong>
      {q.data.maintenance.message ? (
        <span> — {q.data.maintenance.message}</span>
      ) : (
        <span> — Beperkte beschikbaarheid; sync en verzending kunnen vertraagd zijn.</span>
      )}
    </div>
  );
}
